export type CurrentEnvironment = "local" | "dev" | "stg" | "prod" | "stg";

export const getCurrentEnvironment = (): CurrentEnvironment => "stg";

export const appConstants = {
    somethingWentWrongErrorMessage: "Something went wrong",
    apiUrl: "https://app-t-90002666-002-api.azurewebsites.net"
} as const;

export const getClientId = (): string => "c2f3ccee-cb08-448a-b5db-2a8cb6e3c50b";
export const getClientTenant = (): string => "556e6b1f-b49d-4278-8baf-db06eeefc8e9";
export const getClientUri = (): string => window.location.origin + "/";
